module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.6832/images/default-avatar.png"